import type { ReactNode } from "react";

type Tone = "info" | "success" | "warning" | "error";

const tones: Record<Tone, string> = {
  info:    "bg-fh-sage text-fh-green-dark border-fh-green-light",
  success: "bg-fh-sage text-fh-green-dark border-fh-green-light",
  warning: "bg-amber-50 text-amber-900 border-amber-200",
  error:   "bg-red-50 text-red-900 border-red-200",
};

export function Alert({ tone = "info", children }: { tone?: Tone; children: ReactNode }) {
  return (
    <div role="alert" className={`rounded-[10px] border px-3.5 py-2.5 text-[13.5px] ${tones[tone]}`}>
      {children}
    </div>
  );
}
